import { useQuery } from "@tanstack/react-query"

import { DateFilter } from "@/types/filters"

import { supabase } from "../lib/supabase"

export interface CostTrackingStats {
  totalCosts: {
    current: number
    previous: number
    percentChange: number
  }
  costsByType: {
    [key: string]: {
      current: number
      previous: number
      percentChange: number
    }
  }
  costBreakdown: {
    dvla: {
      current: number
      previous: number
      percentChange: number
    }
    rtw: {
      current: number
      previous: number
      percentChange: number
    }
    email: {
      current: number
      previous: number
      percentChange: number
    }
    other: {
      current: number
      previous: number
      percentChange: number
    }
  }
  averageCostPerApplication: {
    current: number
    previous: number
    percentChange: number
  }
}

/**
 * Hook to fetch cost tracking statistics data
 * @param dateFilter - Optional date filter
 * @returns Query result with cost tracking statistics
 */
export const useCostTrackingData = (dateFilter?: DateFilter, jobId?: string) => {
  return useQuery<CostTrackingStats>({
    queryKey: ["costTrackingStats", dateFilter, jobId ?? "all"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("metrics-cost-tracking", {
        body: {
          startDate: dateFilter?.startDate,
          endDate: dateFilter?.endDate,
          jobId: jobId ?? null,
        },
      })

      if (error) {
        throw new Error(`Error fetching cost tracking statistics: ${error.message}`)
      }

      return data
    },
    refetchOnWindowFocus: false,
  })
}
